import {useEffect, useState} from 'react'
import {usersAPI} from '../../../services/UsersService'
import ToggleButton from 'react-bootstrap/esm/ToggleButton'
import {DateRangePickerInput} from '../helpers/DateRangePicker'
import {setQuery} from '../slices/csrFilterSlice'
import {useAppDispatch, useAppSelector} from '../../../hooks/redux'
import ToggleButtonGroup from 'react-bootstrap/esm/ToggleButtonGroup'
import {shallowEqual} from 'react-redux'
import {CSRGroupBy} from '../core/_models'
import {Link, useLocation, useParams} from 'react-router-dom'
import {KTSVG} from '../../../template/helpers'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

const CSRHeader = () => {
  const {appId} = useParams()
  const location = useLocation()
  const dispatch = useAppDispatch()
  const {data: currentUser} = usersAPI.useFetchGetMeQuery()
  const query = useAppSelector((state) => state.csrFilter, shallowEqual)
  const [toggleButtonValue, setToggleButtonValue] = useState<CSRGroupBy>('day')
  const [linkCdr] = useState<string>(location.pathname.includes('/management') ? '/management/cdr' : '/cdr')

  useEffect(() => {
    if (query && query.group_by) {
      setToggleButtonValue(query.group_by)
    }
  }, [query])

  return (
    <div className='card-header border-1'>
      <div className='d-flex align-items-center mt-2 w-100'>
        <div className='d-flex align-items-center gap-2'>
          <div className='w-290px'>
            <DateRangePickerInput
              language={currentUser?.language}
              timeZone={currentUser?.time_zone}
              rangeId='1'
              onlyIcon={false}
            />
          </div>
          <ToggleButtonGroup
            type='radio'
            name='options'
            defaultValue={'day'}
            onChange={(val) => {
              setToggleButtonValue(val)
            }}
          >
            <ToggleButton
              id='tbg-radio-1'
              value={'day'}
              variant={toggleButtonValue === 'day' ? 'primary' : 'outline-primary'}
              size='sm'
              onClick={() => {
                dispatch(setQuery({...query, group_by: 'day'}))
              }}
            >
              По дням
            </ToggleButton>
            <ToggleButton
              id='tbg-radio-2'
              value={'week'}
              variant={toggleButtonValue === 'week' ? 'primary' : 'outline-primary'}
              size='sm'
              onClick={() => {
                dispatch(setQuery({...query, group_by: 'week'}))
              }}
            >
              По неделям
            </ToggleButton>
            <ToggleButton
              id='tbg-radio-3'
              value={'month'}
              variant={toggleButtonValue === 'month' ? 'primary' : 'outline-primary'}
              size='sm'
              onClick={() => {
                dispatch(setQuery({...query, group_by: 'month'}))
              }}
            >
              По месяцам
            </ToggleButton>
          </ToggleButtonGroup>
        </div>
        <div className='ms-auto'>
          <OverlayTrigger
            delay={{show: 50, hide: 50}}
            overlay={
              <Tooltip id='tooltip-title' style={{position: 'fixed'}}>
                Перейти к журналу звонков
              </Tooltip>
            }
          >
            <Link to={`${linkCdr}/${appId}`}>
              <span className='badge badge-light-success cursor-pointer'>
                <KTSVG path='/media/icons/duotune/files/fil002.svg' className='svg-icon-success' />
              </span>
            </Link>
          </OverlayTrigger>
        </div>
      </div>
    </div>
  )
}

export {CSRHeader}
